import { ENVIRONMENT } from "./constants";

export const IS_PROD = process.env.NODE_ENV === "production";
export const REACT_APP_ENV = IS_PROD ? ENVIRONMENT.PROD : ENVIRONMENT.DEV;
export const MAX_POLLINGS_NUMBER = 60;
export const POLL_INTERVAL = 1000;
export const ERRORS_SHOW_TIME = 3000;

export const REACT_APP_VERSION = IS_PROD ? "${REACT_APP_VERSION}" : "0.0.0-dev";
export const REACT_APP_ENABLE_APP_INSIGHTS = IS_PROD;
export const REACT_APP_INSIGHTS_INSTRUMENTATION_KEY = IS_PROD
  ? "${REACT_APP_INSIGHTS_INSTRUMENTATION_KEY}"
  : "";
export const REACT_APP_INSIGHTS_ACCOUNT_ID = "webapp";

export const SERVICE_NAME = "STOCKPILE-MATCHER-PLUS-WEBAPP";

export const GRAPHQL_COSMOSDB_URI = IS_PROD
  ? "${GRAPHQL_COSMOSDB_URI}"
  : process.env.GRAPHQL_COSMOSDB_URI;

export const GRAPHQL_ADX_URI = IS_PROD
  ? "${GRAPHQL_ADX_URI}"
  : process.env.GRAPHQL_ADX_URI;

export const FEEDBACK_FUNCTION_URI = "component-not-used";

export const UI_SP_CLIENT_ID = IS_PROD
  ? "${UI_SP_CLIENT_ID}"
  : process.env.UI_SP_CLIENT_ID;

export const UI_SP_TENANT_ID = IS_PROD
  ? "${UI_SP_TENANT_ID}"
  : process.env.UI_SP_TENANT_ID;
